
import { useState, useEffect, useContext, useMemo } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { useRef } from "react";
import CreateSubGroup from "../SubGroups/CreateSubGroup";
import CreateGroup from "../Groups/CreateGroup";
import CancelButton from "../../../Components/CommonComponent/Button/CancelButton";
import SaveButton from "../../../Components/CommonComponent/Button/SaveButton";
import { CommonContext } from "../../../App";
import { useTranslation } from "react-i18next";
import AddAreaModal from "../../../Components/CommonComponent/Modals/AddAreaModal";
import googleTransliterate from "../../../utils/googleTransliterate";
import AddUnit from "../../../Components/CommonComponent/Units/AddUnit";
import { FaEdit } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import api from "../../../services/api";
import { FaChevronDown } from "react-icons/fa";
import { MdOutlineSubdirectoryArrowRight } from "react-icons/md";

export default function MyForm({ setModalVisible, onUpdateData, ledgerData, updateLedger, initialData, manageStock, addMoreBtn, fetchLedgers, allGroups: propsAllGroups, allSubGroups: propsAllSubGroups, setAllGroups: propsSetAllGroups, setAllSubGroups: propsSetAllSubGroups, editMode, isEdit = { isEdit }, }) {

  const [selectedSections, setSelectedSections] = useState({
    normal: !manageStock,
    bank: false,
    tax: false,
    vehicle: false
  });

  const { t } = useTranslation();
  const [formValues, setFormValues] = useState({});
  const [allGroups, setAllGroups] = useState([]);
  const [allSubGroups, setAllSubGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedSubGroup, setSelectedSubGroup] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [addGroupName, setAddGroupName] = useState("");
  const [subGroupName, setSubGroupName] = useState("");
  const [groupName, setGroupName] = useState("");
  const [subGroupNameInHindi, setSubGroupNameInHindi] = useState("");
  const [groupNameInHindi, setGroupNameInHindi] = useState("");
  const [groupId, setGroupId] = useState("");
  const [subGroupId, setSubGroupId] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addSubGroupType, setAddSubGroupType] = useState("");
  const [typeValidation, setTypeValidation] = useState(false);
  const [nameValidation, setNameValidation] = useState(false);
  const [openingBalanceTypeValidation, setOpeningBalanceTypeValidation] = useState(false);
  const [subGroupValidation, setSubGroupValidation] = useState(false);
  const [selectGroupValidation, setSelectGroupValidation] = useState(false);
  const [groupValidation, setGroupValidation] = useState(false);
  const [groupTypeValidation, setGroupTypeValidation] = useState(false);
  const [subGroupSelectorValidation, setSubGroupSelectorValidation] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [isKeyboardNav, setIsKeyboardNav] = useState(false);
  const [selectedGroupId, setSelectedGroupId] = useState("");
  const [selectedSubGroupId, setSelectedSubGroupId] = useState("");
  const [showField, setShowField] = useState(false);
  const [hindiSuggestion, setHindiSuggestion] = useState('');
  const storedLang = JSON.parse(localStorage.getItem("second_language"));
  const language = storedLang?.language || "en";

  const Types = useMemo(() => {
    return manageStock
      ? [{ name: "Stock", nameInHindi: "स्टॉक" }]
      : [
        { name: "Assets", nameInHindi: "सम्पत्ति, लेनदारी " },
        { name: "Liability", nameInHindi: "दायित्व, देनदारी " },
        { name: "Income", nameInHindi: "कमाई, बिक्री" },
        { name: "Expense", nameInHindi: "खर्च, खरीद" }
      ];
  }, [manageStock]);

  const [addGroupType, setAddGroupType] = useState(Types[0]);
  const dropdownRefs = {
    subgroup: useRef(null),
    group: useRef(null),
    type: useRef(null),
    unit: useRef(null),
    areas: useRef(null),
    suggestion: useRef(null),
  };
  const { branchId } = useContext(CommonContext);
  const subgroupItemRefs = useRef([]);
  const groupItemRefs = useRef([]);
  const unitItemRefs = useRef([]);
  const areaItemRefs = useRef([]);
  const suggestionItemRefs = useRef([]);

  const [areaOptions, setAreaOptions] = useState([]);
  const [loadingAreas, setLoadingAreas] = useState(false);
  const [showAddAreaModal, setShowAddAreaModal] = useState(false);
  const [isSubGroupModalOpen, setIsSubGroupModalOpen] = useState(false);
  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [autoConvertedValue, setAutoConvertedValue] = useState("");
  const [convertedValues, setConvertedValues] = useState({});
  const [nameInHindi, setNameInHindi] = useState("");
  const [allUnits, setAllUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedUnitId, setSelectedUnitId] = useState("");
  const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);
  const [newUnitName, setNewUnitName] = useState("");
  const [unitValidation, setUnitValidation] = useState(false);
  const [typeInHindi, setTypeInHindi] = useState('');
  const [showAreaDropdown, setShowAreaDropdown] = useState(false);
  const [ledgerBatch, setLedgerBatch] = useState([]);
  const [showOpeningBalance, setShowOpeningBalance] = useState(false);
  const [editingBatchIndex, setEditingBatchIndex] = useState(-1);
  const [suggestions, setSuggestions] = useState([]);  
  // ─── Debtors check for area/price visibility ──────────────────────────────
  const isDebtorsGroup = selectedGroup?.trim().toLowerCase() === "debtors";

  // ─── All SubGroups for single selector ───────────────────────────────────
  const getAllSubGroupItems = () => {
    const filtered = allSubGroups.filter((sg) => sg?.subGroupName);
    if (manageStock) {
      const stockGroupIds = allGroups
        .filter((g) => g.type === "Stock")  
        .map((g) => g.id || g.group_id);
      const stockFiltered = filtered.filter((sg) =>
        stockGroupIds.includes(sg.groupId || sg.group_id)
      );
      return [...stockFiltered, { subGroupName: t("addNewSubGroup"), isAddNew: true }];
    }
    return [...filtered, { subGroupName: t("addNewSubGroup"), isAddNew: true }];
  };

  // ─── SubGroup select → auto-set Group & Type ─────────────────────────────
  const handleSubGroupSelectorSelect = (sg) => {
    if (sg.isAddNew) {
      handleOpenSubGroupModal();
      return;
    }

    const parentGroup = allGroups.find(
      (g) => (g.id || g.group_id) === (sg.groupId || sg.group_id)
    );

    if (parentGroup) {
      const typeObj = Types.find((t) => t.name === parentGroup.type) || Types[0];
      setSelectedType(typeObj);
      setSelectedGroup(parentGroup.groupName || parentGroup.group_name || "");
      setSelectedGroupId(parentGroup.id || parentGroup.group_id || "");
      setGroupId(parentGroup.id || parentGroup.group_id || "");
    }

    setSelectedSubGroup(sg.subGroupName);
    setSubGroupNameInHindi(sg.subGroupNameInHindi);
    setSelectedSubGroupId(sg.id || sg.sub_group_id || "");
    setSubGroupId(sg.id || sg.sub_group_id || "");
    setSubGroupSelectorValidation(false);
    setOpenDropdown(null);
    setIsKeyboardNav(false);
    setHighlightedIndex(-1);
  };

  useEffect(() => {
    if (initialData && allGroups.length > 0) {
      if (initialData.name) setFormValues(prev => ({ ...prev, name: initialData.name }));
      if (initialData.address) setFormValues(prev => ({ ...prev, address: initialData.address }));
      if (initialData.phone) setFormValues(prev => ({ ...prev, phone: initialData.phone }));
      if (initialData.group) {
        const foundGroup = allGroups.find(
          (g) => (g.groupName && g.groupName.trim() === initialData.group.trim()) ||
            (g.group_name && g.group_name.trim() === initialData.group.trim()) ||
            g.id === initialData.group || g.groupId === initialData.group
        );
        if (foundGroup) {
          const typeObj = Types.find(t => t.name === foundGroup.type) || Types[0];
          setSelectedType(typeObj);
          setSelectedGroup(foundGroup.groupName || foundGroup.group_name || "");
          setSelectedGroupId(foundGroup.id || foundGroup.group_id || "");
          setGroupId(foundGroup.id || foundGroup.group_id || "");
        }
      }
      if (initialData.type) {
        const typeObj = Types.find(t => t.name === initialData.type);
        if (typeObj) setSelectedType(typeObj);
      }
      if (initialData.subGroup && allSubGroups.length > 0) {
        const foundSubGroup = allSubGroups.find(
          (sg) => sg.subGroupName?.trim() === initialData.subGroup?.trim()
        );
        if (foundSubGroup) {
          setSelectedSubGroup(foundSubGroup.subGroupName);
          setSelectedSubGroupId(foundSubGroup.id || foundSubGroup.sub_group_id);
        }
      }
    }
  }, [initialData, allGroups, allSubGroups, Types]);

  useEffect(() => {
    const fetchAreas = async () => {
      try {
        setLoadingAreas(true);
        const res = await api.get(`area/get-all?branchId=${branchId}&limit=all`);
        let options = [];
        if (Array.isArray(res.data)) {
          options = res.data.map((a) => ({ label: a.name, value: a.id, price: a.price }));
        } else if (res.data?.success && Array.isArray(res.data.data)) {
          options = res.data.data.map((a) => ({ label: a.name, value: a.id, price: a.price }));
        }
        setAreaOptions([{ label: t("addArea"), value: "add_area" }, ...options]);
      } catch (err) {
        console.error("Failed to fetch areas:", err);
        setAreaOptions([{ label: t("addArea"), value: "add_area" }]);
      } finally {
        setLoadingAreas(false);
      }
    };
    if (branchId) fetchAreas();
  }, [branchId, initialData]);

useEffect(() => {
  const handleClickOutside = (event) => {
    const isInsideAnyDropdown = Object.values(dropdownRefs).some(
      (ref) => ref.current && ref.current.contains(event.target)
    );
    if (!isInsideAnyDropdown) {
      setOpenDropdown(null);
      setIsKeyboardNav(false);
      setHighlightedIndex(-1);
      setSuggestions([]);  // ✅ suggestions bhi clear karo
    }
  };
  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

  // useEffect(() => {
  //   let item = null;
  //   if (openDropdown === "subgroup" && highlightedIndex >= 0) item = subgroupItemRefs.current[highlightedIndex];
  //   else if (openDropdown === "unit" && highlightedIndex >= 0) item = unitItemRefs.current[highlightedIndex];
  //   if (item) item.scrollIntoView({ behavior: "smooth", block: "nearest" });
  // }, [highlightedIndex, openDropdown]);

  useEffect(() => {
    let item = null;
    if (openDropdown === "subgroup" && highlightedIndex >= 0) item = subgroupItemRefs.current[highlightedIndex];
    else if (openDropdown === "unit" && highlightedIndex >= 0) item = unitItemRefs.current[highlightedIndex];
    else if (openDropdown === "areas" && highlightedIndex >= 0) item = areaItemRefs.current[highlightedIndex]; 
    else if (openDropdown === "suggestion" && highlightedIndex >= 0) item = suggestionItemRefs.current[highlightedIndex]; 
    if (item) item.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [highlightedIndex, openDropdown]);

  const getUnitItems = () => [...allUnits, { unitName: t("addNewUnit"), isAddNew: true }];

  // const handleKeyDown = (e, items, setSelected, openModalCallback) => {
  //   if (!items || items.length === 0) return;
  //   if (e.key === "ArrowDown") { e.preventDefault(); setIsKeyboardNav(true); setHighlightedIndex((prev) => (prev + 1) % items.length); }
  //   else if (e.key === "ArrowUp") { e.preventDefault(); setIsKeyboardNav(true); setHighlightedIndex((prev) => (prev - 1 + items.length) % items.length); }
  //   else if (e.key === "Enter") {
  //     e.preventDefault();
  //     if (highlightedIndex >= 0) {
  //       const selectedItem = items[highlightedIndex];
  //       if (selectedItem.isAddNew) openModalCallback();
  //       else setSelected(selectedItem.subGroupName || selectedItem.groupName);
  //       setOpenDropdown(null); setIsKeyboardNav(false); setHighlightedIndex(-1);
  //     }
  //   }
  // };

  const handleKeyDown = (e, items, onSelect, openModalCallback) => {
    if (!items || items.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setIsKeyboardNav(true);
      setOpenDropdown((prev) => prev); // dropdown open rakho
      setHighlightedIndex((prev) => (prev + 1) % items.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setIsKeyboardNav(true);
      setHighlightedIndex((prev) => (prev - 1 + items.length) % items.length);
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0) {
        const selectedItem = items[highlightedIndex];
        if (selectedItem.isAddNew) {
          openModalCallback();
        } else {
          onSelect(selectedItem); // ✅ poora object pass karo
        }
        setOpenDropdown(null);
        setIsKeyboardNav(false);
        setHighlightedIndex(-1);
      }
    } else if (e.key === "Escape") {
      setOpenDropdown(null);
      setIsKeyboardNav(false);
      setHighlightedIndex(-1);
    }
  };

  const handleMouseMove = () => { setIsKeyboardNav(false); setHighlightedIndex(-1); };

  const toggleDropdown = (name, itemsLength) => {
    if (openDropdown === name) { setOpenDropdown(null); setHighlightedIndex(-1); setIsKeyboardNav(false); }
    else { setOpenDropdown(name); setHighlightedIndex(itemsLength > 0 ? 0 : -1); setIsKeyboardNav(true); }
  };

  const fetchSubGroups = async () => {
    try {
      const res = await api.get(`groups-types/get-all-sub-group?branchId=${branchId}`);
      if (res.data.success) {
        const newSubGroups = res.data.allData;
        setData(newSubGroups); setAllSubGroups(newSubGroups);
        if (propsSetAllSubGroups) propsSetAllSubGroups(newSubGroups);
      }
    } catch (error) { console.error("Error fetching sub-groups:", error); toast.error("Failed to load sub-groups"); }
  };

  const fetchGroups = async () => {
    try {
      const res = await api.get(`groups-types/get-all-group?branchId=${branchId}`);
      if (res.data.success) {
        const newGroups = res.data.allData;
        setAllGroups(newGroups);
        if (propsSetAllGroups) propsSetAllGroups(newGroups);
      }
    } catch (error) { console.error("Error fetching groups:", error); toast.error("Failed to load groups"); }
  };

  const fetchUnits = async () => {
    try {
      const res = await api.get(`unit/get-all/${branchId}`);
      if (res.data.success) setAllUnits(res.data.allData || res.data.data || []);
    } catch (error) { console.error("Error fetching units:", error); toast.error("Failed to load units"); }
  };

  useEffect(() => { if (branchId) { fetchGroups(); fetchSubGroups(); fetchUnits(); } }, [branchId]);

  useEffect(() => {
    if (selectedSubGroup) {
      const match = allSubGroups.find((item) => item.subGroupName === selectedSubGroup);
      if (match) { setSelectedSubGroupId(match.id || match.sub_group_id || ""); setSubGroupId(match.id || match.sub_group_id || ""); }
    } else { setSelectedSubGroupId(""); setSubGroupId(""); }
  }, [selectedSubGroup, allSubGroups]);

  useEffect(() => {
    if (selectedGroup) {
      const match = allGroups.find((item) => item.groupName === selectedGroup);
      if (match) { setSelectedGroupId(match.id || match.group_id || ""); setGroupId(match.id || match.group_id || ""); }
    } else { setSelectedGroupId(""); setGroupId(""); }
  }, [selectedGroup, allGroups]);

  const handleGroupSelect = (selectedGroupName) => {
    const foundGroup = allGroups.find((g) => g.groupName === selectedGroupName || g.id === selectedGroupName);
    if (foundGroup) { setGroupName(foundGroup.groupName); setGroupId(foundGroup.group_id || foundGroup.id || ""); setAddSubGroupType(foundGroup.type || ""); }
  };

  const handleSubGroupSave = async () => {
    if (!subGroupName.trim()) { setSubGroupValidation(true); return; }
    if (!branchId) { toast.error("Branch is missing!!!"); return; }
    if (!groupName) { setSelectGroupValidation(true); setSubGroupValidation(false); return; }
    setLoading(true);
    const subGroups = [{ subGroupName, subGroupNameInHindi, groupId }];
    try {
      const res = await api.post(`groups-types/new-sub-group`, { branchId, subGroups });
      if (res.data.success) {
        const newSubGroup = res.data.newData;
        setData((prev) => [...prev, newSubGroup]);
        setAllSubGroups((prev) => [...prev, newSubGroup]);
        if (propsSetAllSubGroups) propsSetAllSubGroups((prev) => [...prev, newSubGroup]);
        setSelectedSubGroup(newSubGroup.subGroupName);
        setSelectedSubGroupId(newSubGroup.id);
        const existingGroup = allGroups.find((g) => (g.id || g.group_id) === groupId);
        if (existingGroup) {
          const typeObj = Types.find((t) => t.name === existingGroup.type) || selectedType;
          setSelectedType(typeObj);
          setSelectedGroup(existingGroup.groupName || existingGroup.group_name);
          setSelectedGroupId(existingGroup.id || existingGroup.group_id);
        }
        await fetchSubGroups();
        setSubGroupValidation(false); setSelectGroupValidation(false); setIsSubGroupModalOpen(false);
        setSubGroupName(""); setSubGroupNameInHindi(""); setGroupName(""); setAddSubGroupType("");
        toast.success(res.data.message || "Sub-group added successfully!");
      } else { toast.error(res.data.message || "Failed to add sub-group"); }
    } catch (error) { console.error("Error adding sub-group:", error); toast.error(error.response?.data?.message || "error while adding sub-group"); }
    finally { setLoading(false); }
  };

  const handleSubGroupCancel = () => {
    setIsSubGroupModalOpen(false); setSubGroupValidation(false); setSelectGroupValidation(false);
    setSubGroupName(""); setSubGroupNameInHindi(''); setGroupName(""); setAddSubGroupType("");
  };

  const handleOpenSubGroupModal = () => {
    setIsSubGroupModalOpen(true);
    if (selectedGroupId && selectedGroup) {
      const foundGroup = allGroups.find(g => (g.id || g.group_id) === selectedGroupId);
      if (foundGroup) { setGroupName(foundGroup.groupName || foundGroup.group_name); setGroupId(foundGroup.id || foundGroup.group_id); setAddSubGroupType(foundGroup.type || ""); }
    }
  };

  const nameFixed = { header: "Name", placeholder: "name", inputType: "input", type: "text", active: true };
  const unitFixed = [
    { header: t("unit"), placeholder: "unit", inputType: "dropdown", active: true },
    { header: t("PricePerQuantity"), placeholder: "perQuantity", inputType: "input", type: "number", max: 130, active: true, disabled: isEdit },
  ];

  // ── normalDetails: area & price REMOVED — shown separately after name ──
  const normalDetails = [
    { header: t("address"), placeholder: "address", inputType: "input", type: "text", active: true },
    { header: t("phone"), placeholder: "phone", inputType: "input", type: "number", max: 10, active: true },
    { header: t("emailAddress"), placeholder: "email", inputType: "input", type: "text", active: true },
    { header: t("uploadDocuments"), placeholder: "document", inputType: "file", active: true },
  ];
  const bankDetails = [
    { header: t("accountName"), placeholder: "accountName", inputType: "input", type: "text", active: true },
    { header: t("accountNumber"), placeholder: "accountNumber", inputType: "input", type: "number", max: 12, active: true },
    { header: t("branchName"), placeholder: "branch", inputType: "input", type: "text", active: true },
    { header: t("ifsCode"), placeholder: "ifsc", inputType: "input", type: "text", active: true },
    { header: t("address"), placeholder: "bankAddress", inputType: "input", type: "text", active: true },
    { header: t("uploadBankDocuments"), placeholder: "bankDocument", inputType: "file", active: true },
  ];
  const taxDetails = [
    { header: t("panNumber"), placeholder: "panNumber", inputType: "input", type: "text", max: 10, active: true },
    { header: t("gstNumber"), placeholder: "gstNumber", inputType: "input", type: "number", max: 15, active: true },
    { header: t("uploadTaxDocuments"), placeholder: "taxDocument", inputType: "file", active: true },
  ];
  const vehicleDetails = [
    { header: t("vehicleModel"), placeholder: "vehicleModel", inputType: "input", type: "text", active: true },
    { header: t("registrationNumber"), placeholder: "registrationNumber", inputType: "input", type: "text", active: true },
    { header: t("insuranceExpiryDate"), placeholder: "insuranceDate", inputType: "input", type: "date", active: true },
    { header: t("pollutionExpiryDate"), placeholder: "pollutionDate", inputType: "input", type: "date", active: true },
    { header: t("mileage"), placeholder: "mileage", inputType: "input", type: "text", active: true },
    { header: t("capacity"), placeholder: "capacity", inputType: "input", type: "text", active: true },
    { header: t("uploadDocuments"), placeholder: "document", inputType: "file", active: true },
  ];
  const fixedFieldBalance = [
    { header: "Opening Balance", placeholder: "openingBalance", inputType: "input", type: "number", active: true },
    { header: "Opening Balance Type", placeholder: "openingBalanceType", inputType: "input", type: "text", active: true },
  ];
  const fixedFieldStock = [
    { header: "Opening Stock", placeholder: "openingStock", inputType: "input", type: "number", active: true },
  ];
  const fieldsConfig = {
    normal: { title: t("ledgerDetails"), fields: normalDetails },
    bank: { title: t("bankDetails"), fields: bankDetails },
    tax: { title: t("taxDetails"), fields: taxDetails },
    vehicle: { title: t("vehicleDetails"), fields: vehicleDetails },
  };

  const stripDecimal = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    return String(Math.floor(num));
  };

  const handleCheckboxChange = (section) => setSelectedSections((prev) => ({ ...prev, [section]: !prev[section] }));

  const getSafeFileArray = (fieldValue) => {
    if (Array.isArray(fieldValue)) return fieldValue;
    if (typeof fieldValue === 'string' && fieldValue.trim()) {
      try { const parsed = JSON.parse(fieldValue); return Array.isArray(parsed) ? parsed : []; }
      catch (e) { return []; }
    }
    return [];
  };

  const handleInputChange = async (field, value) => {
    if (field.inputType === "file") {
      setFormValues((prev) => { const currentFiles = getSafeFileArray(prev[field.placeholder]); return { ...prev, [field.placeholder]: [...currentFiles, value] }; });
    } else {
      let filteredValue = value;
      if (field.type === "number") filteredValue = value.replace(/[^0-9.]/g, "").replace(/^(\d*\.?\d*).*$/, '$1');
      if (field.max) filteredValue = filteredValue.slice(0, field.max);
      setFormValues((prev) => ({ ...prev, [field.placeholder]: filteredValue }));
    }
    // if (field.placeholder === "name") {
    //   try { if (language !== "en") { const converted = await googleTransliterate(value, language); setNameInHindi(converted); } }
    //   catch (err) { console.error("Transliteration error:", err); }
    // }
    if (field.placeholder === "name") {
  try {
    if (language !== "en") {
      const result = await googleTransliterate(value, language);

      setNameInHindi(result.text);
      setSuggestions(result.suggestions);
    }
  } catch (err) {
    console.error("Transliteration error:", err);
  }
}
    if (language !== "en") {
      const converted = await googleTransliterate(value, language);
      setConvertedValues((prev) => ({ ...prev, [field.placeholder]: converted }));
    }
  };

  // const handleConvertNameInHindi = async (e) => {
  //   const value = e.target.value;
  //   setHindiSuggestion(value);
  //   try { if (language !== "en") { const converted = await googleTransliterate(value, language); setNameInHindi(converted); } }
  //   catch (err) { console.error("Transliteration error:", err); }
  // };

  const handleConvertNameInHindi = async (e) => {
  const value = e.target.value;
  setHindiSuggestion(value);

  try {
    if (language !== "en") {
      const result = await googleTransliterate(value, language);

      setNameInHindi(result.text);
      setSuggestions(result.suggestions || []);
    }
  } catch (err) {
    console.error("Transliteration error:", err);
  }
};
  const handleFixedInputChange = (field, value) => {
    let filteredValue = value;
    if (field.type === "number") filteredValue = value.replace(/[^0-9.]/g, "").replace(/^(\d*\.?\d*).*$/, '$1');
    if (field.max) filteredValue = filteredValue.slice(0, field.max);
    setFormValues((prev) => ({ ...prev, [field.placeholder]: filteredValue }));
  };

  const buildCurrentLedgerObject = () => ({
    ...formValues,
    subGroup: selectedSubGroupId, group: selectedGroupId, branchId, unit: selectedUnitId, secondValue: nameInHindi,
    _displayType: selectedType?.name || "", _displayGroup: selectedGroup || "", _displaySubGroup: selectedSubGroup || "",
    _displayUnit: selectedUnit || "", _selectedType: selectedType, _selectedGroup: selectedGroup,
    _selectedGroupId: selectedGroupId, _selectedSubGroup: selectedSubGroup, _selectedSubGroupId: selectedSubGroupId,
    _selectedUnit: selectedUnit, _selectedUnitId: selectedUnitId, _nameInHindi: nameInHindi,
    _selectedSections: { ...selectedSections },
  });

  const resetFormFields = (keepSelections = false) => {
    setFormValues({ name: "", openingBalance: "", openingBalanceType: "", document: [], bankDocument: [], taxDocument: [], description: "", address: "", phone: "", email: "", pinCode: "" });
    setNameInHindi(""); setHindiSuggestion("");
    setSelectedSections({ normal: !manageStock, bank: false, tax: false, vehicle: false });
    setSubGroupSelectorValidation(false); setNameValidation(false); setOpeningBalanceTypeValidation(false);
    if (!keepSelections) {
      setSelectedType(""); setSelectedGroup(""); setSelectedGroupId("");
      setSelectedSubGroup(""); setSelectedSubGroupId(""); setSelectedUnit(""); setSelectedUnitId("");
    }
    setEditingBatchIndex(-1);
  };

  const validateCurrentForm = () => {
    if (!selectedSubGroupId) { setSubGroupSelectorValidation(true); return false; }
    if (!formValues.name) { setSubGroupSelectorValidation(false); setNameValidation(true); setOpeningBalanceTypeValidation(false); return false; }
    if (selectedType?.name === "Stock" || manageStock) {
      if (!selectedUnitId) { toast.error("Unit is required for Stock items!"); return false; }
      if (!formValues.perQuantity) { toast.error("Price per Quantity is required for Stock items!"); return false; }
    }
    if (selectedType?.name !== "Stock" && formValues.openingBalance && !formValues.openingBalanceType) {
      setOpeningBalanceTypeValidation(true); setNameValidation(false); return false;
    }
    return true;
  };

  const handleAddMore = async () => {
    if (!validateCurrentForm()) return;
    const ledgerObj = buildCurrentLedgerObject();
    if (editingBatchIndex >= 0) {
      setLedgerBatch(prev => { const updated = [...prev]; updated[editingBatchIndex] = ledgerObj; return updated; });
      toast.success(`Ledger updated in batch!`);
    } else {
      setLedgerBatch(prev => [...prev, ledgerObj]);
      toast.success(`Ledger added to batch (${ledgerBatch.length + 1} total)`);
    }
    setSubGroupSelectorValidation(false); setNameValidation(false); setOpeningBalanceTypeValidation(false);
    resetFormFields(true);
  };

  const handleEditBatchItem = (index) => {
    const item = ledgerBatch[index];
    setEditingBatchIndex(index);
    const restoredFormValues = {};
    Object.keys(item).forEach(key => { if (!key.startsWith("_")) restoredFormValues[key] = item[key]; });
    setFormValues(restoredFormValues);
    setSelectedType(item._selectedType || ""); setSelectedGroup(item._selectedGroup || "");
    setSelectedGroupId(item._selectedGroupId || ""); setSelectedSubGroup(item._selectedSubGroup || "");
    setSelectedSubGroupId(item._selectedSubGroupId || ""); setSelectedUnit(item._selectedUnit || "");
    setSelectedUnitId(item._selectedUnitId || ""); setNameInHindi(item._nameInHindi || "");
    setHindiSuggestion(item.name || "");
    if (item._selectedSections) setSelectedSections(item._selectedSections);
  };

  const handleRemoveBatchItem = (index) => {
    setLedgerBatch(prev => prev.filter((_, i) => i !== index));
    if (editingBatchIndex === index) resetFormFields(true);
    else if (editingBatchIndex > index) setEditingBatchIndex(prev => prev - 1);
    toast.success("Ledger removed from batch");
  };

  const handleSaveAll = async () => {
    if (ledgerBatch.length === 0) { await handleSave(true); return; }
    let finalBatch = [...ledgerBatch];
    if (formValues.name && selectedGroupId && selectedSubGroupId) {
      if (validateCurrentForm()) {
        const currentLedger = buildCurrentLedgerObject();
        if (editingBatchIndex >= 0) finalBatch[editingBatchIndex] = currentLedger;
        else finalBatch.push(currentLedger);
      }
    }
    const cleanBatch = finalBatch.map(item => {
      const clean = {};
      Object.keys(item).forEach(key => { if (!key.startsWith("_")) clean[key] = item[key]; });
      return clean;
    });
    try {
      const response = await api.post(`ledgers/create-ledger`, { branchId, ledgers: cleanBatch }, { headers: { "Content-Type": "application/json" }, timeout: 30000 });
      if (response.data.success) {
        if (onUpdateData) onUpdateData(); if (updateLedger) updateLedger(); if (fetchLedgers) fetchLedgers();
        toast.success(`${cleanBatch.length} ledgers created successfully!`);
        setLedgerBatch([]); resetFormFields(false);
        if (setModalVisible) setModalVisible(false);
      } else { toast.error(response.data.message || "Failed to create ledgers"); }
    } catch (error) { console.error("Error creating batch ledgers:", error); toast.error(error.response?.data?.message || "failed to create ledgers"); }
  };

  const handleSave = async (closeModal = true) => {
    if (loading) return;
    if (!selectedSubGroupId) { setSubGroupSelectorValidation(true); return; }
    if (!branchId) { toast.error("Branch is missing!"); return; }
    if (!formValues.name) { setSubGroupSelectorValidation(false); setNameValidation(true); setOpeningBalanceTypeValidation(false); return; }
    if (selectedType?.name === "Stock" || manageStock) {
      if (!selectedUnitId) { toast.error("Unit is required for Stock items!"); return; }
      if (!formValues.perQuantity) { toast.error("Price per Quantity is required for Stock items!"); return; }
    }
    if (selectedType?.name !== "Stock" && formValues.openingBalance && !formValues.openingBalanceType) {
      setNameValidation(false); setOpeningBalanceTypeValidation(true); toast.error("Opening Balance Type is required"); return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      const completeData = { ...formValues, subGroup: selectedSubGroupId, group: selectedGroupId, branchId, unit: selectedUnitId };
      if (nameInHindi) completeData.secondValue = nameInHindi;
      const existingDocument = getSafeFileArray(formValues.document).filter(v => typeof v === "string");
      const existingBankDocument = getSafeFileArray(formValues.bankDocument).filter(v => typeof v === "string");
      const existingTaxDocument = getSafeFileArray(formValues.taxDocument).filter(v => typeof v === "string");
      if (ledgerData?.id) {
        formData.append("existingDocument", JSON.stringify(existingDocument));
        formData.append("existingBankDocument", JSON.stringify(existingBankDocument));
        formData.append("existingTaxDocument", JSON.stringify(existingTaxDocument));
      }
      Object.keys(completeData).forEach((key) => {
        const value = completeData[key];
        if (Array.isArray(value)) { value.forEach((file) => { if (file instanceof File) formData.append(key, file); }); }
        else if (value !== null && value !== undefined && value !== "") { formData.append(key, String(value)); }
      });
      const isUpdate = ledgerData?.id;
      const response = isUpdate
        ? await api.post(`ledgers/update-ledger?id=${ledgerData.id}`, formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 30000 })
        : await api.post(`ledgers/create-ledger`, formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 30000 });
      if (response.data?.success) {
        if (onUpdateData) await onUpdateData(); if (updateLedger) await updateLedger(); if (fetchLedgers) await fetchLedgers();
        if (response.status === 207) toast.success(response.data.message);
        else toast.success(isUpdate ? t("ledgerUpdatedSuccess") : t("ledgerCreatedSuccess"));
        setSubGroupSelectorValidation(false); setNameValidation(false); setOpeningBalanceTypeValidation(false);
        resetFormFields(false);
        if (closeModal && setModalVisible) setModalVisible(false);
      } else { toast.error(response.data?.message || "Something went wrong"); }
    } catch (error) {
      console.error("Ledger save error:", error);
      const backendMessage = error?.response?.data?.message || error?.response?.data?.error || error?.response?.data?.msg;
      if (error?.response?.status === 409) { toast.error(backendMessage || "Duplicate entry found!"); return; }
      const validationErrors = error?.response?.data?.errors;
      if (validationErrors && typeof validationErrors === "object") Object.values(validationErrors).flat().forEach(msg => toast.error(msg));
      else toast.error(backendMessage || "Failed to create ledger. Please try again.");
    } finally {
      setLoading(false); setSubGroupSelectorValidation(false); setNameValidation(false); setOpeningBalanceTypeValidation(false);
      resetFormFields(false);
    }
  };

  useEffect(() => {
    if (ledgerData && ledgerData.id) {
      const processedData = { ...ledgerData };
      ['document', 'bankDocument', 'taxDocument'].forEach(fileField => { if (processedData[fileField]) processedData[fileField] = getSafeFileArray(processedData[fileField]); });
      if (ledgerData.areaId) { processedData.area_id = ledgerData.areaId; processedData.area = ledgerData.areaId; }
      if (ledgerData.areaPrice) processedData.price = ledgerData.areaPrice;
      if (ledgerData.areaName) processedData.area_name = ledgerData.areaName;
      const cleanedData = { ...processedData };
      ["openingBalance", "price", "perQuantity", "openingStock"].forEach((key) => { if (cleanedData[key] !== undefined) cleanedData[key] = stripDecimal(cleanedData[key]); });
      setFormValues((prev) => ({ ...prev, ...cleanedData }));
      if (ledgerData.cousinName) { setNameInHindi(ledgerData.cousinName); setHindiSuggestion(ledgerData.name); }
      if (ledgerData.groupTypeInHindi) setTypeInHindi(ledgerData.groupTypeInHindi);
      if (ledgerData.showOpeningBalane) setShowOpeningBalance(ledgerData.showOpeningBalane);
      if (ledgerData.subGroupId) {
        const typeObj = Types.find(t => t.name === (ledgerData.subGroupType || ledgerData.groupType)) || Types[0];
        setSelectedType(typeObj); setSelectedGroup(ledgerData.groupName || ""); setSelectedGroupId(ledgerData.groupId || "");
        setSelectedSubGroup(ledgerData.subGroupName || ""); setSubGroupNameInHindi(ledgerData.subGroupNameInHindi || "");
        setSelectedSubGroupId(ledgerData.subGroupId || "");
      } else if (ledgerData.groupId) {
        const typeObj = Types.find(t => t.name === ledgerData.groupType) || Types[0];
        setSelectedType(typeObj); setSelectedGroup(ledgerData.groupName || ""); setSelectedGroupId(ledgerData.groupId || "");
        setSelectedSubGroup(""); setSubGroupNameInHindi(""); setSelectedSubGroupId("");
      } else {
        setSelectedType(manageStock ? Types.find(t => t.name === "Stock") || Types[0] : Types[0]);
        setSelectedGroup(""); setSelectedGroupId(""); setSelectedSubGroup(""); setSubGroupNameInHindi(""); setSelectedSubGroupId("");
      }
      if (ledgerData.unitName) { setSelectedUnit(ledgerData.unitName); setSelectedUnitId(ledgerData.unitId); }
      const newSections = { ...selectedSections };
      if (ledgerData.accountName || ledgerData.accountNumber || ledgerData.bankName) newSections.bank = true;
      if (ledgerData.panNumber || ledgerData.gstNumber) newSections.tax = true;
      if (ledgerData.vehicleModel || ledgerData.registrationNumber) newSections.vehicle = true;
      if (ledgerData.address || ledgerData.phone || ledgerData.email || ledgerData.areaId || ledgerData.areaPrice) newSections.normal = true;
      setSelectedSections(newSections);
    } else {
      setFormValues({ name: "", openingBalance: "", openingBalanceType: "", document: [], bankDocument: [], taxDocument: [], description: "", address: "", phone: "", email: "", pinCode: "", area_id: "", price: "" });
      setSelectedType(manageStock ? Types.find(t => t.name === "Stock") || Types[0] : Types[0]);
      setSelectedGroup(""); setSelectedGroupId(""); setSelectedSubGroup(""); setSelectedSubGroupId(""); setSelectedUnit("");
      setSelectedSections({ normal: !manageStock, bank: false, tax: false, vehicle: false });
    }
  }, [ledgerData]);

  const handleCancel = () => {
    setFormValues({}); setSelectedType(""); setSelectedSubGroup(""); setSelectedGroup("");
    setSubGroupSelectorValidation(false); setTypeValidation(false); setGroupValidation(false);
    setNameValidation(false); setOpeningBalanceTypeValidation(false);
    setSelectedSubGroupId(""); setSelectedGroupId(""); setSelectedUnit("");
    setLedgerBatch([]); setEditingBatchIndex(-1);
    if (setModalVisible) setModalVisible(false);
    setSelectedSections({ normal: !manageStock, bank: false, tax: false, vehicle: false });
  };

  const handleGroupSave = async () => {
    if (!addGroupName.trim()) { setGroupValidation(true); return; }
    if (!branchId) { toast.error("Missing branch!"); return; }
    if (!addGroupType) { setGroupTypeValidation(true); setGroupValidation(false); return; }
    setLoading(true);
    const payload = { branchId, groups: [{ groupName: addGroupName, groupNameInHindi, type: addGroupType.name, typeInHindi: addGroupType.nameInHindi }] };
    try {
      const res = await api.post(`groups-types/new-group`, payload);
      if (res.data.success) {
        const newGroup = res.data.newData;
        setAllGroups((prev) => [...prev, newGroup]);
        if (propsSetAllGroups) propsSetAllGroups((prev) => [...prev, newGroup]);
        const typeObj = Types.find((t) => t.name === newGroup.type) || addGroupType;
        setSelectedType(typeObj); setSelectedGroup(newGroup.groupName); setSelectedGroupId(newGroup.id); setGroupId(newGroup.id);
        setSelectedSubGroup(""); setSelectedSubGroupId("");
        await fetchGroups(); setAddGroupName(""); setGroupNameInHindi(""); setGroupValidation(false); setGroupTypeValidation(false); setIsGroupModalOpen(false);
        toast.success(res.data.message || "Group added successfully");
      } else { toast.error(res.data.message || "Failed to add group"); }
    } catch (err) { console.error("Error adding group", err); toast.error(err.response?.data?.message || "Failed to add group"); }
    finally { setLoading(false); }
  };

  const handleGroupModelCancel = () => { setIsGroupModalOpen(false); setGroupTypeValidation(false); setGroupValidation(false); setAddGroupName(""); setGroupNameInHindi(''); };

  const handleAreaAdded = (newArea) => {
    setAreaOptions((prev) => [prev[0], ...prev.slice(1), { label: newArea.name, value: newArea.id, price: newArea.price }]);
    setFormValues((prev) => ({ ...prev, area_id: newArea.id, area: newArea.id, area_name: newArea.name, price: newArea.price }));
  };

  const handleUnitAdded = (newUnit) => {
    const unitName = newUnit.unitName || newUnit.unit_name || newUnit.name || "";
    const unitId = newUnit.id || "";
    setAllUnits((prev) => [...prev, newUnit]); setSelectedUnit(unitName); setSelectedUnitId(unitId);
    setFormValues((prev) => ({ ...prev, unit: unitId }));
  };

  const handleUnitSave = async () => {
    if (!newUnitName.trim()) { setUnitValidation(true); return; }
    if (!branchId) { toast.error("Branch is missing!"); return; }
    setLoading(true);
    try {
      const res = await api.post(`units/create`, { unitName: newUnitName, branchId });
      if (res.data.success) {
        const newUnit = res.data.newData || res.data.data;
        setAllUnits([...allUnits, newUnit]); setSelectedUnit(newUnit.unitName || newUnit.unit_name); setSelectedUnitId(newUnit.id);
        setNewUnitName(""); setUnitValidation(false); setIsUnitModalOpen(false); fetchUnits();
        toast.success(res.data.message || "Unit added successfully!");
      } else { toast.error(res.data.message || "Failed to add unit"); }
    } catch (error) { console.error("Error adding unit:", error); toast.error("error while adding unit"); }
    finally { setLoading(false); }
  };

  const handleUnitCancel = () => { setIsUnitModalOpen(false); setUnitValidation(false); setNewUnitName(""); };

  return (
    <div className="px-2 pb-2 bg-white shadow max-w-6xl mx-auto border z-[99]">

      {/* ── Header ── */}
      <div className="bg-white pt-2 sticky top-0 z-[99]">
        <div className="bg-theme-headerBg text-theme-color flex justify-center rounded-1 py-[2px] px-2 mb-2">
          <div className="ms-auto font-medium">{editMode ? t('editLedger') : t('createNewLedger')}</div>
          <div className="ms-auto">
            <ImCross className="mt-[5px] text-sm pe-[2px] cursor-pointer" onClick={handleCancel} />
          </div>
        </div>
      </div>

      {/* ── Batch Ledger List ── */}
      {ledgerBatch.length > 0 && (
        <div className="mb-3 px-2">
          <div className="text-sm font-medium text-theme-headerBg mb-1 underline underline-offset-4">
            {t("listOfAddedLedgers")} ({ledgerBatch.length})
          </div>
          <div className="flex flex-col gap-1 max-h-40 overflow-y-auto pr-1">
            {ledgerBatch.map((item, index) => (
              <div key={index} className={`flex items-center justify-between rounded border px-3 py-[5px] text-sm transition-all ${editingBatchIndex === index ? "border-theme-headerBg bg-theme-headerBg/10 font-medium" : "border-gray-200 bg-gray-50 hover:bg-gray-100"}`}>
                <div className="flex items-center gap-2 flex-1 min-w-0">
                  <span className="text-gray-400 text-xs w-5 shrink-0">{index + 1}.</span>
                  <span className="truncate font-medium text-gray-800 capitalize">
                    {item.name}
                    {item._nameInHindi && <span className="text-gray-400 font-normal ml-1">({item._nameInHindi})</span>}
                  </span>
                  <span className="text-gray-400 text-xs hidden sm:inline shrink-0">
                    {item._displayType && `• ${item._displayType}`}
                    {item._displayGroup && ` / ${item._displayGroup}`}
                    {item._displaySubGroup && ` / ${item._displaySubGroup}`}
                  </span>
                </div>
                <div className="flex items-center gap-2 ml-2 shrink-0">
                  {editingBatchIndex === index
                    ? <span className="text-xs text-theme-headerBg italic">{t("editing")}</span>
                    : <button type="button" title="Edit this ledger" onClick={() => handleEditBatchItem(index)} className="text-gray-500 hover:text-theme-headerBg transition-colors p-1 rounded"><FaEdit className="text-sm" /></button>
                  }
                  <button type="button" title="Remove this ledger" onClick={() => handleRemoveBatchItem(index)} className="text-gray-400 hover:text-red-500 transition-colors p-1 rounded"><ImCross className="text-xs" /></button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── Row 1: SubGroup + Name + Hindi ── */}
      <div className="px-2 mb-">
       <div className="grid grid-cols-3 md:grid-cols-4 gap-3 items-start">

          {/* SubGroup Dropdown */}
          <div className="w-full flex flex-col" ref={dropdownRefs.subgroup}>
            <label className="block font-medium text-sm">{t('selectSubGroup')} : </label>
            <div
              tabIndex={0}
              className={`border ${subGroupSelectorValidation ? "border-red-500" : ""} bg-gray-100 px-2 py-1 rounded w-full cursor-pointer relative`}
              onClick={() => toggleDropdown("subgroup", getAllSubGroupItems().length)}
              // onKeyDown={(e) => handleKeyDown(e, getAllSubGroupItems(), () => { }, handleOpenSubGroupModal)}
              onKeyDown={(e) => handleKeyDown(
                e,
                getAllSubGroupItems(),
                (sg) => handleSubGroupSelectorSelect(sg),   // ✅ object milega
                handleOpenSubGroupModal
              )}
              onMouseMove={handleMouseMove}
            >
              {selectedSubGroup ? (
                <span>
                  {selectedSubGroup}
                  <span className="font-normal text-xs">
                    {language !== "en" && subGroupNameInHindi && ` ( ${subGroupNameInHindi} )`}
                  </span>
                </span>
              ) : (
                <span className="text-gray-400">{t("selectSubGroup") || "Select Sub Group"}</span>
              )}
              <FaChevronDown className={`absolute right-2 top-1/2 -translate-y-1/2 text-sm transition-transform duration-300 ${openDropdown === "subgroup" ? "rotate-180" : ""}`} />
              <ul className={`absolute top-full left-0 w-full bg-white border mt-1 z-10 rounded shadow max-h-60 overflow-auto transition-all custom-scrollbar p-0 ${openDropdown === "subgroup" ? "block" : "hidden"}`}>
                {getAllSubGroupItems().map((sg, idx) => (
                  <li
                    key={idx}
                    ref={(el) => (subgroupItemRefs.current[idx] = el)}
                    onClick={(e) => { e.stopPropagation(); handleSubGroupSelectorSelect(sg); }}
                    className={`px-3 py-1 cursor-pointer text-sm font-medium border-dashed border-b ${isKeyboardNav ? highlightedIndex === idx ? "bg-theme-headerBg text-theme-color" : "" : "hover:bg-theme-headerBg hover:text-theme-color"} ${sg.isAddNew ? "font-medium text-theme-tabHoverColor" : ""}`}
                  >
                    {sg.subGroupName}
                    <span className="font-normal text-xs">
                      {language !== "en" && sg.subGroupNameInHindi && ` ( ${sg.subGroupNameInHindi} )`}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
            {subGroupSelectorValidation && (
              <div className="text-red-500 text-sm px-2">{t("pleaseSelectSubGroup") || "Please select a sub group"}</div>
            )}
            {/* Auto-selected Type & Group chips */}
            {selectedSubGroup && (
              <div className="flex gap-1 mt-1 flex-wrap">

                {selectedGroup && (
                  <span className="text-xs bg-theme-headerBg/10 text-theme-headerBg px-2 py-[2px] rounded-full border border-theme-headerBg/30 font-medium">
                    {t("group") || "Group"} : {selectedGroup}
                    {language !== "en" && allGroups.find(g => g.groupName === selectedGroup)?.groupNameInHindi
                      ? ` (${allGroups.find(g => g.groupName === selectedGroup)?.groupNameInHindi})` : ""}
                  </span>
                )}
                {selectedType?.name && (
                  <span className="text-xs bg-theme-headerBg/10 text-theme-headerBg px-2 py-[2px] rounded-full border border-theme-headerBg/30 font-medium">
                    {t("type") || "Type"} : {selectedType.name}
                    {language !== "en" && selectedType.nameInHindi ? ` (${selectedType.nameInHindi})` : ""}
                  </span>
                )}
              </div>
            )}
          </div>

          {/* Name */}
          <div>
            <label className="block font-medium text-sm ">
              {t((!manageStock && selectedType?.name !== "Stock") ? 'accountName' : 'ItemName')} : 
            </label>
            <input
              type="text"
              value={formValues[nameFixed.placeholder] || ""}
              onChange={(e) => { handleInputChange(nameFixed, e.target.value); setHindiSuggestion(e.target.value); }}
              className={`border ${nameValidation ? "border-danger" : ""} capitalize px-2 py-1 rounded w-full bg-gray-100`}
              placeholder={nameFixed.placeholder}
            
            />
            <div className="text-red-600 text-sm px-2">{nameValidation && t("nameValidation")}</div>
          </div>

          {/* Hindi name edit */}
          {showField && (
            <div>
              <label className="block font-medium text-sm">
                {t('enterTranslateValue')} : 
              </label>
              <div className="flex">
                <input type="text" value={hindiSuggestion} onChange={handleConvertNameInHindi} placeholder="Enter name" className="border outline-none rounded-s capitalize bg-gray-100 w-full py-[4px] px-2" />
                <div className="border px-2 ms-auto w-8 cursor-pointer rounded-e bg-gray-100">
                  <ImCross className="mt-2 text-theme-createLedgerColor" onClick={() => setShowField(false)} />
                </div>
              </div>
            </div>
          )}

          {/* Transliterate */}
          {/* {language !== "en" && (
            <div>
              <label className="block font-medium text-sm">{language === "hi" ? t("translateinHindi") : t("translateinPunjabi")} : </label>
              <div className="flex">
                <input type="text" value={nameInHindi} disabled placeholder="Translate Value" className="border px-2 py-1 rounded-s w-full capitalize cursor-not-allowed bg-gray-100" />
                <div className="border px-2 ms-auto w-8 cursor-pointer rounded-e bg-gray-100">
                  <FaEdit className="mt-2" onClick={() => setShowField(true)} />
                </div>
              </div>
            </div>
            
          )} */}
          
{language !== "en" && (
  <div className="relative" ref={dropdownRefs.suggestion}>  {/*  ref add karo */}
    <label className="block font-medium text-sm">
      {language === "hi" ? t("translateinHindi") : t("translateinPunjabi")} :
    </label>

    <div className="flex">
      <input
        type="text"
        value={nameInHindi}
        disabled
        placeholder="Translate Value"
        className="border px-2 py-1 rounded-s w-full capitalize cursor-not-allowed bg-gray-100"
      />
      <div className="border px-2 ms-auto w-8 cursor-pointer rounded-e bg-gray-100">
        <FaEdit className="mt-2" onClick={() => setShowField(true)} />
      </div>
    </div>

    {/* Suggestions Dropdown */}
    {suggestions.length > 0 && (
      <ul className="absolute left-0 top-full w-full border rounded bg-white shadow mt-1 z-[999] max-h-40 overflow-auto p-0">
        {suggestions.slice(0, 4).map((s, index) => (
          <li
            key={index}
            ref={(el) => (suggestionItemRefs.current[index] = el)}
            className={`px-2 py-1 cursor-pointer border-dashed border-b text-sm
              ${isKeyboardNav && openDropdown === "suggestion" && highlightedIndex === index
                ? "bg-theme-headerBg text-theme-color"
                : "hover:bg-theme-headerBg hover:text-theme-color"
              }`}
            onMouseMove={() => {
              setIsKeyboardNav(false);
              setHighlightedIndex(index);
            }}
            onClick={() => {
              setNameInHindi(s);
              setSuggestions([]);
              setOpenDropdown(null);
              setHighlightedIndex(-1);
            }}
          >
            {s}
          </li>
        ))}
      </ul>
    )}
  </div>
)}
          {/* {isDebtorsGroup && !manageStock && selectedType?.name !== "Stock" && (
  <div className="" ref={dropdownRefs.areas}>
    <label className="block text-sm">{t("area")} :</label>
    <div className="relative w-full">
      <button
        type="button"
        disabled={loadingAreas}
        className="w-full border px-2 py-[3px] rounded bg-gray-100 text-left flex justify-between items-center focus:outline-none capitalize"
        onClick={() =>
          setOpenDropdown((prev) => (prev === "areas" ? null : "areas"))
        }
      >
        <span>{formValues.area_name || t("selectArea") || "Select Transportation Area"}</span>
        <span className={`text-sm transition-transform duration-200 ${openDropdown === "areas" ? "rotate-180" : "rotate-0"}`}>
          <FaChevronDown />
        </span>
      </button>

      {openDropdown === "areas" && (
        <ul className="absolute p-0 z-50 w-full bg-white border rounded shadow max-h-40 overflow-y-auto custom-scrollbar">
          {areaOptions.map((opt, i) => (
            <li
              key={String(opt.value) || i}
              className="px-2 py-1 cursor-pointer hover:bg-theme-headerBg hover:text-theme-color border-dashed border-b"
              onClick={() => {
                if (opt.value === "add_area") {
                  setShowAddAreaModal(true);
                } else {
                  setFormValues((prev) => ({
                    ...prev,
                    area_id: opt.value,
                    area: opt.value,
                    area_name: opt.label,
                    price: opt.price,
                  }));
                }
                setOpenDropdown(null); // ✅ close on select
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
)} */}
          {isDebtorsGroup && !manageStock && selectedType?.name !== "Stock" && (
            <div className="" ref={dropdownRefs.areas}>
              <label className="block font-medium text-sm">{t("area")} :</label>
              <div className="relative w-full">
                <button
                  type="button"
                  tabIndex={0}
                  disabled={loadingAreas}
                  className="w-full border px-2 py-[3px] rounded bg-gray-100 text-left flex justify-between items-center focus:outline-none capitalize"
                  onClick={() => {
                    setOpenDropdown((prev) => (prev === "areas" ? null : "areas"));
                    setHighlightedIndex(0);
                    setIsKeyboardNav(true);
                  }}
                  onKeyDown={(e) => {
                    if (!areaOptions.length) return;
                    if (e.key === "ArrowDown") {
                      e.preventDefault();
                      setOpenDropdown("areas");
                      setIsKeyboardNav(true);
                      setHighlightedIndex((prev) =>
                        prev < areaOptions.length - 1 ? prev + 1 : 0
                      );
                    } else if (e.key === "ArrowUp") {
                      e.preventDefault();
                      setOpenDropdown("areas");
                      setIsKeyboardNav(true);
                      setHighlightedIndex((prev) =>
                        prev > 0 ? prev - 1 : areaOptions.length - 1
                      );
                    } else if (e.key === "Enter") {
                      e.preventDefault();
                      if (openDropdown === "areas" && highlightedIndex >= 0) {
                        const opt = areaOptions[highlightedIndex];
                        if (opt.value === "add_area") {
                          setShowAddAreaModal(true);
                        } else {
                          setFormValues((prev) => ({
                            ...prev,
                            area_id: opt.value,
                            area: opt.value,
                            area_name: opt.label,
                            price: opt.price,
                          }));
                        }
                        setOpenDropdown(null);
                        setHighlightedIndex(-1);
                        setIsKeyboardNav(false);
                      }
                    } else if (e.key === "Escape") {
                      setOpenDropdown(null);
                      setHighlightedIndex(-1);
                      setIsKeyboardNav(false);
                    }
                  }}
                >
                  <span>{formValues.area_name || t("selectArea") || "Select Transporte Area"}</span>
                  <span className={`text-sm transition-transform duration-200 ${openDropdown === "areas" ? "rotate-180" : "rotate-0"}`}>
                    <FaChevronDown />
                  </span>
                </button>

                {openDropdown === "areas" && (
                  <ul className="absolute p-0 z-50 w-full bg-white border rounded shadow max-h-40 overflow-y-auto custom-scrollbar">
                    {areaOptions.map((opt, i) => (
                      <li
                        key={String(opt.value) || i}
                        ref={(el) => (areaItemRefs.current[i] = el)}
                        className={`px-2 py-1 cursor-pointer border-dashed border-b
                ${isKeyboardNav
                            ? highlightedIndex === i
                              ? "bg-theme-headerBg text-theme-color"
                              : ""
                            : "hover:bg-theme-headerBg hover:text-theme-color"
                          }`}
                        onMouseMove={() => {
                          setIsKeyboardNav(false);
                          setHighlightedIndex(i);
                        }}
                        onClick={() => {
                          if (opt.value === "add_area") {
                            setShowAddAreaModal(true);
                          } else {
                            setFormValues((prev) => ({
                              ...prev,
                              area_id: opt.value,
                              area: opt.value,
                              area_name: opt.label,
                              price: opt.price,
                            }));
                          }
                          setOpenDropdown(null);
                          setHighlightedIndex(-1);
                          setIsKeyboardNav(false);
                        }}
                      >
                        {opt.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          )}

          {isDebtorsGroup && !manageStock && selectedType?.name !== "Stock" && (
            <div>
              <label className="block font-medium text-sm">{t("price")} :</label>
              <input
                type="number"
                placeholder="price"
                value={formValues.price || ""}
                onChange={(e) => {
                  let v = e.target.value.replace(/[^0-9.]/g, "").replace(/^(\d*\.?\d*).*$/, '$1').slice(0, 100);
                  setFormValues((prev) => ({ ...prev, price: v }));
                }}
                className="border px-2 py-[3px] rounded w-full outline-none bg-gray-100"
              />
            </div>
          )}
          {(manageStock || selectedType?.name === "Stock") && (
            <div className=" mb-2">
              <div ref={dropdownRefs.unit}>
                <label className="block font-medium text-sm">{unitFixed[0].header} : </label>
                <div
                  tabIndex={0}
                  className="border px-2 py-1 rounded w-full bg-gray-100 cursor-pointer relative"
                  onClick={() => toggleDropdown("unit", getUnitItems().length)}
                  // onKeyDown={(e) => handleKeyDown(e, getUnitItems(), setSelectedUnit, () => setIsUnitModalOpen(true))}
                  onKeyDown={(e) => handleKeyDown(
                    e,
                    getUnitItems(),
                    (unit) => {
                      setSelectedUnit(unit.unitName || unit.name);
                      setSelectedUnitId(unit.id);
                    },
                    () => setIsUnitModalOpen(true)
                  )}
                  onMouseMove={handleMouseMove}
                >
                  {selectedUnit || "Select Unit"}
                  <FaChevronDown className={`absolute right-2 top-1/2 -translate-y-1/2 text-sm transition-transform duration-300 ${openDropdown === "unit" ? "rotate-180" : ""}`} />
                  <ul className={`absolute top-full left-0 w-full bg-white border mt-1 z-10 rounded shadow max-h-60 overflow-auto transition-all p-0 text-sm ${openDropdown === "unit" ? "block" : "hidden"}`}>
                    {getUnitItems().map((unit, idx) => (
                      <li
                        key={idx}
                        ref={(el) => (unitItemRefs.current[idx] = el)}
                        onClick={() => {
                          if (unit.isAddNew) { setIsUnitModalOpen(true); }
                          else { setSelectedUnit(unit.unitName || unit.name); setSelectedUnitId(unit.id); }
                          setOpenDropdown(null); setIsKeyboardNav(false); setHighlightedIndex(-1);
                        }}
                        className={`px-2 py-1 text-sm cursor-pointer border-dashed border-b  ${isKeyboardNav ? highlightedIndex === idx ? "bg-theme-headerBg text-theme-color" : "" : "hover:bg-theme-headerBg hover:text-theme-color"} ${unit.isAddNew ? "font-bold text-theme-tabHoverColor" : ""}`}
                      >
                        {unit.unitName || unit.name}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          )}
          {(manageStock || selectedType?.name === "Stock") && (
            <div className=" mb-2">
              <label className="block font-medium  text-sm">{unitFixed[1].header} : </label>
              <input
                type={unitFixed[1].type}
                value={formValues[unitFixed[1].placeholder] || ""}
                onChange={(e) => handleInputChange(unitFixed[1], e.target.value)}
                maxLength={unitFixed[1].max || undefined}
                disabled={unitFixed[1].disabled}
                className={`border px-2 py-1 rounded w-full outline-none capitalize ${unitFixed[1].disabled ? "bg-gray-200 cursor-not-allowed" : "bg-gray-100"}`}
                placeholder={unitFixed[1].placeholder}
              />
            </div>
          )}

        </div>
      </div>
      {(!manageStock && selectedType?.name !== "Stock") && (
        <div className="flex gap-6 justify-center py-1  border-t border-b text-theme-headerBg mt-3 border-theme-headerBg">
          <label className="flex items-center gap-2 text-sm font-medium">
            <input type="checkbox" checked={selectedSections.normal} onChange={() => handleCheckboxChange("normal")} className="accent-theme-headerBg" />
            {t('ledgerDetails')}
          </label>
          <label className="flex items-center text-sm gap-2 font-medium">
            <input type="checkbox" checked={selectedSections.bank} onChange={() => handleCheckboxChange("bank")} className="accent-theme-headerBg" />
            {t('bankDetails')}
          </label>
          <label className="flex items-center text-sm gap-2 font-medium">
            <input type="checkbox" checked={selectedSections.tax} onChange={() => handleCheckboxChange("tax")} className="accent-theme-headerBg" />
            {t('taxDetails')}
          </label>
          <label className="flex items-center text-sm gap-2 font-medium">
            <input type="checkbox" checked={selectedSections.vehicle} onChange={() => handleCheckboxChange("vehicle")} className="accent-theme-headerBg" />
            {t('vehicleDetails')}
          </label>
        </div>
      )}

      {Object.keys(selectedSections).filter((key) => selectedSections[key]).map((sectionKey) => {
        const section = fieldsConfig[sectionKey];
        return (
          <div key={sectionKey} className="px-2">
            <div className="font-medium mt-2 underline underline-offset-4 text-[14px]">{section.title}</div>
            <div className="grid grid-cols-3 md:grid-cols-4 gap-3">
              {section.fields.map((field, fIdx) => (
                <div className="mt-2" key={fIdx}>
                  <label className="block font-medium text-sm">{field.header} : </label>
                  {field.inputType === "input" ? (
                    <input
                      type={field.type || "text"} placeholder={field.placeholder}
                      value={formValues[field.placeholder] || ""} maxLength={field.max || undefined} max={field.max || undefined}
                      onChange={(e) => handleInputChange(field, e.target.value)}
                      className="border px-2 py-1 rounded w-full outline-none bg-gray-100"
                    />
                  ) : (
                    /* File input */
                    <div className="flex flex-col">
                      <div className="flex flex-wrap gap-3">
                        {getSafeFileArray(formValues[field.placeholder]).map((file, idx) => (
                          <div key={idx} className="relative w-24 h-24 border border-gray-300 rounded overflow-hidden">
                            <div className={`absolute top-0 left-0 px-1 text-xs text-white rounded-br ${file instanceof File ? "bg-green-500" : "bg-blue-500"}`}>
                              {file instanceof File ? "NEW" : "SAVED"}
                            </div>
                            {file instanceof File ? (
                              file.type && file.type.startsWith("image/") ? (
                                <img src={URL.createObjectURL(file)} alt="preview" className="w-full h-full object-cover" />
                              ) : (
                                <div className="flex items-center justify-center w-full h-full bg-gray-100 text-gray-600">{file.name || "File"}</div>
                              )
                            ) : typeof file === "string" && file.match(/\.(jpg|jpeg|png|gif|bmp|webp)$/i) ? (
                              <img src={`http://localhost:4300${file}`} alt="existing file" className="w-full h-full object-cover" onError={(e) => { e.target.style.display = "none"; e.target.nextElementSibling.style.display = "flex"; }} />
                            ) : (
                              <div className="flex items-center justify-center w-full h-full bg-gray-100 text-xs text-gray-600">{typeof file === "string" ? file.split("/").pop() : "File"}</div>
                            )}
                            <button
                              type="button"
                              className="absolute top-1 right-1 bg-red-500 text-white rounded-full px-1 text-xs hover:bg-red-600"
                              onClick={() => { setFormValues((prev) => { const currentFiles = getSafeFileArray(prev[field.placeholder]); return { ...prev, [field.placeholder]: currentFiles.filter((_, i) => i !== idx) }; }); }}
                              title={file instanceof File ? "Remove new file" : "Remove saved file"}
                            >✕</button>
                          </div>
                        ))}
                      </div>
                      <div className="flex items-center gap-2">
                        <input
                          type="file" multiple placeholder={field.placeholder}
                          onChange={(e) => {
                            if (e.target.files.length > 0) {
                              const newFiles = Array.from(e.target.files).filter((f) => f.size < 5 * 1024 * 1024);
                              setFormValues((prev) => ({ ...prev, [field.placeholder]: [...getSafeFileArray(prev[field.placeholder]), ...newFiles] }));
                              e.target.value = "";
                            }
                          }}
                          className="border border-gray-300 w-full rounded px-2 py-[2px] bg-gray-100"
                        />
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}

      {/* ── Opening Balance / Opening Stock ── */}
      <div className=" px-2 ">
        {selectedType && selectedType.name !== "Income" && selectedType.name !== "Expense" && (
          <div className="my-2  ">
            {(!manageStock && selectedType.name !== "Stock") && <div className="font-medium mb-1 underline underline-offset-4 text-[14px]">{t('openingBalance')}</div>}
            {(selectedType.name === "Stock" || manageStock) && <div className="font-medium mb-1 underline underline-offset-4">{t('openingStockhd')}</div>}
            <div className="">
              <div className="mt-2 grid grid-cols-4 md:grid-cols-4 gap-3">
                {(selectedType.name === "Stock" || manageStock) && (
                  <div>
                    <label className="text-sm font-medium ">{t('openingStock')} : </label>
                    <input type="text" value={formValues[fixedFieldStock[0].placeholder] || ""} onChange={(e) => handleInputChange(fixedFieldStock[0], e.target.value)} className="border px-2 py-1 rounded w-full bg-gray-100 outline-none capitalize" placeholder="opening stock" />
                  </div>
                )}
              </div>
              {selectedType.name !== "Stock" && !manageStock && (
                <>
                  <div className="w-full">
                    <label className="text-sm font-medium block">
                      {t('openingBalance')} :{" "}
                      {showOpeningBalance && <span className="text-red-500 text-sm mb-1 inline-block">({t("opningBalanceDisableMessage")})</span>}
                    </label>
                    <div className="max-w-52">
                      <input
                        type="text" value={formValues[fixedFieldBalance[0].placeholder] || ""}
                        onChange={(e) => handleInputChange(fixedFieldBalance[0], e.target.value)}
                        className={`border ${openingBalanceTypeValidation ? "border-danger" : ""} ${showOpeningBalance ? "cursor-not-allowed bg-gray-200" : ""} px-2 py-1 rounded bg-gray-100 w-full`}
                        placeholder="opening balance" disabled={showOpeningBalance}
                      />
                    </div>
                  </div>
                  <div className="flex justify-start gap-6 pt-2 px-4">
                    <label className="flex items-center text-sm gap-2 font-medium">
                      <input type="radio" name="openingBalanceType" value="received" checked={formValues.openingBalanceType === "received"} onChange={(e) => handleFixedInputChange(fixedFieldBalance[1], e.target.value)} disabled={showOpeningBalance} />
                      {t('receivable')}
                    </label>
                    <label className="flex items-center text-sm gap-2 font-medium">
                      <input type="radio" name="openingBalanceType" value="paid" checked={formValues.openingBalanceType === "paid"} onChange={(e) => handleFixedInputChange(fixedFieldBalance[1], e.target.value)} disabled={showOpeningBalance} />
                      {t('payable')}
                    </label>
                  </div>
                  <div className="text-red-600 text-sm px-2">{openingBalanceTypeValidation && t("openingTypeValidation")}</div>
                </>
              )}
            </div>
          </div>
        )}
      </div>

      {/* ── Action Buttons ── */}
      <div className="flex justify-end gap-4 mt-6 mb-2 px-2">
        <div className="flex gap-3">
          <CancelButton onClick={handleCancel} text={t('cancel')} />
          {!ledgerData?.id && addMoreBtn && (
            <SaveButton onClick={handleAddMore} text={editingBatchIndex >= 0 ? t("edit") : (t('addMore') || 'Add More')} />
          )}
          <SaveButton
            onClick={handleSaveAll}
            text={ledgerBatch.length > 0 ? t("saveAll") : t(loading ? t('procssing') : t('save'))}
            disabled={loading}
          />
        </div>
      </div>

      {/* ── Modals ── */}
      {isSubGroupModalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-black/15 bg-opacity-50 z-[1000]">
          <CreateSubGroup
            subGroupName={subGroupName} setSubGroupName={setSubGroupName}
            subGroupNameInHindi={subGroupNameInHindi} setSubGroupNameInHindi={setSubGroupNameInHindi}
            subGroupValidation={subGroupValidation} groupName={groupName} groupId={groupId}
            setGroupId={setGroupId} setGroupName={setGroupName} selectGroupValidation={selectGroupValidation}
            groupType={addSubGroupType} setGroupType={setAddSubGroupType} setIsGroupModalOpen={setIsGroupModalOpen}
            handleGroupSelect={handleGroupSelect} handleSubGroupCancel={handleSubGroupCancel}
            handleSave={handleSubGroupSave} loading={loading} allGroupsData={allGroups}
            addMoreButton={false} isEditMode={false} subGroupBatch={[]} setSubGroupBatch={() => { }}
          />
        </div>
      )}

      {isGroupModalOpen && (
        <div className="fixed inset-0 flex justify-center items-center bg-black/20 bg-opacity-10 z-[1100]">
          <CreateGroup
            groupName={addGroupName} setGroupName={setAddGroupName}
            groupNameInHindi={groupNameInHindi} setGroupNameInHindi={setGroupNameInHindi}
            groupValidation={groupValidation} groupType={addGroupType} setGroupType={setAddGroupType}
            groupTypeValidation={groupTypeValidation} isDropdownOpen={isDropdownOpen} setIsDropdownOpen={setIsDropdownOpen}
            setGroupTypeValidation={setGroupTypeValidation} types={Types} handleSave={handleGroupSave}
            handleCancel={handleGroupModelCancel} loading={loading} handleGroupSelect={handleGroupSelect}
            setAddGroupType={setAddGroupType} addMoreButton={false}
          />
        </div>
      )}

      {showAddAreaModal && <AddAreaModal onClose={() => setShowAddAreaModal(false)} onAreaAdded={handleAreaAdded} addMultiple={false} />}
      {isUnitModalOpen && <AddUnit onClose={() => setIsUnitModalOpen(false)} onUnitAdded={handleUnitAdded} onUpdate={fetchUnits} />}
    </div>
  );
}